import "./AdministrativeStaff.css";

function AdministrativeStaff({ facultyMembers }) {
  const navigateToDetails = (url) => {
    window.location.href = `/${url}`;  
  };

  const renderFacultyMembers = (department) => {
    return facultyMembers
      .filter((member) => member.facultyDepartment === department)
      .map((member) => (
        <div className="administrative-faculty-card" key={member.id}>
          <img src={member.image} alt={member.name} />
          <h3>{member.name}</h3>
          <p>{member.position}</p>
          <button onClick={() => navigateToDetails(member.url)}>
            View Profile
          </button>
        </div>
      ));
  };

  return (
    <div className="administrative-faculty-container">
      <div className="administrative-faculty-section">
        <h2>Administrative Staff</h2>
        <div className="administrative-faculty-row">
          {renderFacultyMembers("Administrative Staff")}
        </div>
      </div>
    </div>
  );
}

export default AdministrativeStaff;
